import { ReactComponent as CalendarIcon } from 'src/assets/calendar.svg';
import { ReactComponent as LocationIcon } from 'src/assets/location_alt.svg';
import { ReactComponent as OrganizerIcon } from 'src/assets/organizer_alt.svg';
import { ReactComponent as TimeIcon } from 'src/assets/time_alt.svg';
import TimeSpan from 'src/components/time-span/time-span';
import css from './event-info.module.scss';
import { EventView, RecurrenceType } from 'src/types/events';
import DayMonthSpan from 'src/components/day-month-span/day-month-span';
import EventContact from './event-contact';
import classNames from 'classnames';

interface EventInfoProps {
  event: EventView;
  showDate?: boolean;
  className?: string;
  showRecurrenceName?: boolean;
}

export default function EventInfo({
  event,
  showDate = false,
  className = '',
  showRecurrenceName = false
}: Readonly<EventInfoProps>) {
  const getRecurrenceName = () => {
    switch (event.recurrenceType) {
      case RecurrenceType.Daily:
        return 'Щоденно';
      case RecurrenceType.Weekly:
        return 'Щотижнево';
      case RecurrenceType.Monthly:
        return 'Щомісячно';
      default:
        return null;
    }
  };

  return (
    <div className={css.info}>
      <div className={classNames(css.infoItem, className)}>
        <LocationIcon />
        <p>{event.locationName}</p>
      </div>
      {showDate && (
        <div className={classNames(css.infoItem, className)}>
          <CalendarIcon />
          <p>
            {event.recurrenceType !== RecurrenceType.None &&
              showRecurrenceName &&
              `${getRecurrenceName()} починаючи з `}
            <DayMonthSpan dateAsNumber={event.scheduledAt} />
          </p>
        </div>
      )}
      <div className={classNames(css.infoItem, className)}>
        <TimeIcon />
        {event.timeOfDay ? <p>{event.timeOfDay?.slice(0, 5)}</p> : <TimeSpan utc={event.scheduledAt} />}
      </div>
      {event.organizerName && (
        <div className={classNames(css.infoItem, className)}>
          <OrganizerIcon />
          <p>{event.organizerName}</p>
        </div>
      )}
      {event.contact && <EventContact contact={event.contact} className={css.infoItem} />}
    </div>
  );
}
